import { render } from "./follow-up.html?vue&type=template&id=208a5194&scoped=true&ts=true&external"
import script from "./follow-up.ts?vue&type=script&lang=ts&external"
export * from "./follow-up.ts?vue&type=script&lang=ts&external"

import "./follow-up.scss?vue&type=style&index=0&id=208a5194&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-208a5194"]])

export default __exports__